export default __webpack_public_path__ + "static/media/SIAKNG-SLCM-Dark.0ebde4d6.svg";